import { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Why from "@/components/Why";
import About from "@/components/About";
import Services from "@/components/Services";
import Process from "@/components/Process";
import QuoteForm from "@/components/QuoteForm";
import Coverage from "@/components/Coverage";
import Affiliations from "@/components/Affiliations";
import Careers from "@/components/Careers";
import Contact from "@/components/Contact";
import FreightAnimation from "@/components/FreightAnimation";
import Footer from "@/components/Footer";

export default function Home() {
  // Intersection observer for reveal animations
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Nav />
      <main>
        <Hero />
        <Why />
        <About />
        <Services />
        <Process />
        <QuoteForm />
        <Coverage />
        <Affiliations />
        <Careers />
        <Contact />
        <FreightAnimation />
      </main>
      <Footer />
    </div>
  );
}
